import React from 'react';
import PropTypes from 'prop-types';
import TableReport from '@componentes/TableReport';
import IntlMessage from "../../../../../helpers/intlMessage";

const SepultamentoInividual = ({ data }) => (
  <div style={{ padding: '0 40px', background: '#fff' }}>
    <TableReport
      title={<IntlMessage id = "dashboards.reports.burialReport"/>}
      assinatura={<IntlMessage id = "dashboards.reports.subscriptionCRM"/>}
    >
      <table
        className='mv-table-relatorio-individual'
        style={{ marginTop: '30px' }}
      >
        <tr>
          <td><IntlMessage id = "dashboards.examDetail.patient"/> {data.paciente}
            {data.pacienteNomeSocial && <div><IntlMessage id = "dashboards.examDetails.socialName"/> {data.pacienteNomeSocial}</div>}</td>
        </tr>
        <tr>
          <td><IntlMessage id = "dashboards.reports.medicalRecord"/>: {data.laudoId}</td>
        </tr>
        <tr>
          <td><IntlMessage id = "dashboards.examDetails.birthDate"/> {data.dataNascimentoPaciente}</td>
        </tr>
      </table>
      <table
        className='mv-table-relatorio-individual'
        style={{ marginTop: '30px' }}
      >
        <tbody>
          <tr>
            <td><IntlMessage id = "dashboards.reports.discardDate"/>: {data.dataDescarte}</td>
          </tr>
          <tr>
            <td><IntlMessage id = "dashboards.examDetail.Material"/> {data.nomeMaterial}</td>
          </tr>
        </tbody>
      </table>
      <table
        className='mv-table-relatorio-individual'
        style={{ marginTop: '30px' }}
      >
        <tbody>
          <tr>
            <td colSpan='2' style={{ height: '200px' }}>
              <IntlMessage id = "dashboards.reports.indication"/> {data.indicacao}
            </td>
          </tr>
        </tbody>
      </table>
    </TableReport>
  </div>
);

SepultamentoInividual.propTypes = {
  data: PropTypes.object.isRequired
};

SepultamentoInividual.defaultProps = {
  data: {}
};

export default SepultamentoInividual;



// WEBPACK FOOTER //
// ./src/pages/descarte/common/components/SepultamentoInividual/index.js